/**
 * Copyright (c) 2026 Spicy Friends Ltd.
 * All rights reserved.
 *
 * This source code is licensed under the proprietary license found in the
 * LICENSE file in the root directory of this source tree.
 */

/** Values shared by rendezvous list filter forms (URL-backed). */
export type RendezvousListFilterFormValues = {
  name?: string
  distance: number[]
  rendezvousType: string[]
  sortBy?: string
  showPast?: boolean
}

export const DEFAULT_RENDEZVOUS_LIST_DISTANCE = 200

/** Build filter form values from route-resolved search params. */
export function rendezvousListFilterFormValuesFromResolvedParams(params: {
  name?: string
  distance?: number
  rendezvousType?: string[]
  sortBy?: string
  showPast?: boolean
}): RendezvousListFilterFormValues {
  return {
    name: params.name ?? '',
    distance: [params.distance ?? DEFAULT_RENDEZVOUS_LIST_DISTANCE],
    rendezvousType: params.rendezvousType ?? [],
    sortBy: params.sortBy,
    showPast: params.showPast,
  }
}

export function rendezvousTypeSelectOptions(t: (key: string) => string): Array<{ label: string; value: string }> {
  return [
    { label: t('Coffee Date'), value: 'COFFEE_DATE' },
    { label: t('Lunch Date'), value: 'LUNCH_DATE' },
    { label: t('Dinner Date'), value: 'DINNER_DATE' },
    { label: t('Drinks Date'), value: 'DRINKS_DATE' },
    { label: t('Club Meet'), value: 'CLUB_MEET' },
    { label: t('Play Date'), value: 'PLAY_DATE' },
    { label: t('Other'), value: 'OTHER' },
  ]
}
